import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { SelectItem } from '@siemens/element-ng/select';
import { Location } from '@tran-monorepo/interfaces/applications';
import { SelectComponent } from '../select';

@Component({
    selector: 'tran-location-selector',
    imports: [SelectComponent, TranslatePipe],
    templateUrl: './location-selector.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LocationSelectorComponent {
    public readonly control = input.required<FormControl<Location[]>>();
    public readonly label = input<string>();
    public readonly placeholder = input<string>('components.location-selector.select-locations');
    public readonly errorMessage = input<string>('components.location-selector.min1');
    public readonly selectAllLabel = input<string>('components.location-selector.select-all-label');
    public readonly locations = input<Location[]>([]);
    public readonly submitted = input(false);
    public readonly readonly = input(false);

    protected readonly options = computed<SelectItem<Location>[]>(() => {
        return this.locations().map(location => ({
            type: 'option',
            value: location as Location,
            label: location.name
        }));
    });
}
